import styled from 'styled-components';
import { colors } from '../../constants/theme';
import MEDIA from '../../helpers/mediaTemplates';
export const Container = styled.footer.withConfig({
  displayName: "footercss__Container",
  componentId: "sc-7ugh9c-0"
})(["padding:4rem 0;border-top:1px solid ", ";", ""], colors.lightGrey, MEDIA.TABLET`
    display: block;
  `);
export const Social = styled.div.withConfig({
  displayName: "footercss__Social",
  componentId: "sc-7ugh9c-1"
})(["margin-bottom:1rem !important;margin:auto;width:fit-content;a{padding:1.5rem;@media (max-width:357px){padding:1.3rem;}}"]);
export const Copyright = styled.div.withConfig({
  displayName: "footercss__Copyright",
  componentId: "sc-7ugh9c-2"
})(["width:fit-content;margin:auto;a{color:", ";transition:color 0.2s ease;text-decoration:none;&:hover{color:inherit;}}"], colors.grey);